import angular from 'angular';
import doctorListComponent from './doctor-list.component';

const doctorList = angular
	.module('doctorList', [])
	.component('doctorList', doctorListComponent)
	.name;

export default doctorList;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-list/doctor-list.modules.js